import { app } from "../serviceLMS";

export async function fetchAllActiveUsersNonPaginated() {
  try {
    const response = await app.get(
      "user/api/client-api/admin/active-employees",
    );
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        message: response.data.message || "Failed to fetch active users.",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: error?.response?.data?.message || "Error fetching active users.",
    };
  }
}

export async function fetchAllCoursesNonPaginated() {
  try {
    const response = await app.get("course/api/client-api/course");
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        message: response.data.message || "Failed to fetch data ",
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Error fetching all courses",
    };
  }
}

export async function fetchAllGroupsNonPaginated() {
  try {
    const response = await app.get(
      "user/api/client-api/group/all-active-groups",
    );
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        message: response.data.message || "Failed to fetch data ",
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Error fetching all groups",
    };
  }
}

export async function fetchAllBundlesNonPaginated() {
  try {
    const response = await app.get("course/api/client-api/bundles");
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        message: response.data.message || "Failed to fetch data ",
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Error fetching all bundles",
    };
  }
}
export async function fetchAllEnrollments(params) {
  try {
    const response = await app.get("user/api/client-api/enrollment/dashboard-enrollments", {params});
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        message: response.data.message || "Failed to fetch data ",
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Error fetching enrollments",
    };
  }
}


export async function fetchEnrollmentsFilter(params) {
  try {
    const response = await app.get("user/api/client-api/enrollment/filter-options", );
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        message: response.data.message || "Failed to fetch data ",
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Error fetching all courses",
    };
  }
}


export async function fetchEnrollmentsStats() {
  try {
    const response = await app.get("/user/api/client-api/enrollment/statistics");
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        message: response.data.message || "Failed to fetch data ",
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Error fetching all courses",
    };
  }
}


export async function addEnrollment(payload) {
  try {
    const response = await app.post(
      "user/api/client-api/enrollment/enroll",
      payload,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
}
